<div class="filter-for-list" *ngIf="!readOnly">
  <mat-form-field class="mini-list-header"placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput [value]="projectUsers ? projectUsers.filter : null" (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>



  <div class="deviceTypeFilter" style="margin-left:50px" placement="right"
       [ngbTooltip]="'ROLES_TYPE_CHIPS' | translate">

    <mat-chip-list>
      <mat-chip *ngFor="let role of roles  index as i "
                [ngClass]="{'selected' : role.name === rolesSelected}"
                (click)="filterListByRole(role.name)">
        {{role.name | translate}}
      </mat-chip>
    </mat-chip-list>

  </div>


  <!--<span>Nb users : {{countUsers}}</span>  <span>Roles : {{rolesSelected}}</span>-->
  <button  type="button" class="btn top-list-tools" (click)="openModal(content)" placement="left"
          [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
    <fa-icon [icon]="faPlus"></fa-icon>
    {{'ADD_USER'|translate}}
  </button>

  <br clear="both"/>
</div>
<div *ngIf="readOnly">
  <b [innerHtml]="'USERS'|translate">Users</b>
  <app-button-project-edit [selectedStep]="3"></app-button-project-edit>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>



<table mat-table [dataSource]="projectUsers" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="userEmail">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMAIL'|translate}}</th>
    <td mat-cell *matCellDef="let user"> <b>{{user.userEmail}}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="userFirstname">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'FIRSTNAME'|translate}}</th>
    <td mat-cell *matCellDef="let user"> {{user.userFirstname}}
    </td>
  </ng-container>


  <ng-container matColumnDef="userLastname">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LASTNAME'|translate}}</th>
    <td mat-cell *matCellDef="let user"> {{user.userLastname}}
    </td>
  </ng-container>

  <ng-container matColumnDef="userRoles">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ROLES'|translate}}</th>
    <td mat-cell *matCellDef="let user">
        <span class="inner-badge"
              *ngFor="let role of getClientOrInstallerRoles(user.userRoles)">{{role}}</span>
    </td>
  </ng-container>


  <ng-container matColumnDef="mainRole">
    <th mat-header-cell *matHeaderCellDef>{{'PROJECT_ROLES'|translate}}</th>
    <td mat-cell *matCellDef="let user">

      <mat-slide-toggle (change)="patchProjectUserMainClient(user.projectUserId,!user.is_main_client)" style="margin:0px !important;" class="sliderActiveList" [ngModel]="user.is_main_client"
                        placement="right">{{'MAIN_CLIENT' | translate}}
      </mat-slide-toggle>

      <!--<mat-slide-toggle (change)="patchProjectUserMainBusiness(user.projectUserId,!user.is_main_business)"  style="margin:0px !important;" class="sliderActiveList" [ngModel]="user.is_main_business"-->
                        <!--placement="right"-->
                        <!--[ngbTooltip]="'ALARMS_SEND_SMS_TOOLTIP' | translate">{{'MAIN_BUSINESS' | translate}}-->
      <!--</mat-slide-toggle>-->
    </td>
  </ng-container>


  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let user">

      <mat-icon style="color:red;cursor:pointer" (click)="removeUserToProject(user.projectUserId, user.userEmail)"
                matTooltipPosition="right"
                [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
      </mat-icon>
    </td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5" *ngIf="!readOnly"></mat-paginator>
